import script from "./UserProfileMain.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfileMain.vue?vue&type=script&setup=true&lang=js"

import "./UserProfileMain.vue?vue&type=style&index=0&id=2138925d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2138925d"]])

export default __exports__